import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export const DEPLOY_ENV = publicRuntimeConfig.DEPLOY_ENV;

export const KE_HOST = 'https://ke.youdao.com'
export const KE_TURING_TAG = `${KE_HOST}/tag/1528?Pdt=CourseWeb`
export const ICODE_CONTEST = 'https://oj.youdao.com'
export const POPADS_SDK = 'https://shared.ydstatic.com/ke/sdk/popadsdk.js'
export const WORK_THEME = [
  {
    key: 'all',
    value: '全部'
  },
  {
    key: 'play',
    value: '游戏',
    belong: 'blockly'
  },
  {
    key: 'story',
    value: '故事',
    belong: 'blockly'
  },
  {
    key: 'art',
    value: '艺术',
    belong: 'blockly'
  },
  {
    key: 'minecraft',
    value: 'Minecraft',
    belong: 'blockly'
  },
  {
    key: 'scratch',
    value: '图形化',
    belong: 'scratch'
  },
  {
    key: 'turtle',
    value: '海龟',
    belong: 'python'
  },
]

export const CODE_LANGUAGE = [
  {
    key: 'all',
    value: '全部'
  },
  {
    key: 'blockly',
    value: 'Blockly创作'
  },
  {
    key: 'scratch',
    value: '图形化创作'
  },
  {
    key: 'python',
    value: 'Python创作'
  },
]

export const RELEASE_STATUS = [
  {
    key: 2,
    value: '已发布'
  },
  {
    key: 1,
    value: '待发布'
  }
]

export const SCRATCH_HOST = process.env.NEXT_PUBLIC_SCRATCH_HOST || 'http://shequ.youdao.com/csl/scratch'

export const YD_COURSE_APP_API_SUPPORT_VERSION_LIST: Record<string, {android: string, ios: string}> = {
  'close': {
    android: '6.0.6',
    ios: '6.0.5'
  },
  'setHorizontalScreen': {
    android: '6.0.6',
    ios: '6.0.5'
  },
  'setFullScreen': {
    android: '6.0.6',
    ios: '6.0.5'
  },
};

export const LOG = {
  visit_ide: {
    icodeshequ_banner_bottom: '社区banner下方入口',
    icodeshequ_nav: '社区顶部导航栏',
    icodeshequ_adapt: '改编',
    oj: 'OJ入口'
  },
  visit_work: {
    recommend: '精品推荐',
    rank: '人气周榜',
    new: '最新作品',
    discovery: '发现页',
    home: '个人/TA的主页', 
    management: '作品管理',
    more: 'TA的更多作品'
  },
  visit_index: {
    oj: '信息学OJ',
    icode: 'iCode旧主站'
  }
}

// 政策合规需求开关，可能存在上线又下线
// 参考：https://gitlab.corp.youdao.com/icode/turingshequ/-/commit/a025f5552721201ec83f2980fcb6ac2df65ec174
// https://confluence.inner.youdao.com/pages/viewpage.action?pageId=218516961
export const COMPLIANCE = false